<template>
  <div v-if="active" class="megamenu-overlay" @click="closeOverlay()">overlay mega menu</div>
</template>

<script>
export default {
  name: 'megamenuoverlay',
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on('show.megamenuoverlay', () => {
        this.active = true;
      });
    }
  },
  methods: {
    showOverlay() {
      this.active = false;
    },
    closeOverlay() {
      this.active = false;

      /* istanbul ignore next */
      if (window.eventBus) {
        window.eventBus.$emit('update.itemmegamenu', false);
        window.eventBus.$emit('update.itemnavigation', false);
        document.querySelector('body').classList.remove('no-scroll');
      }
    },
  },
};
</script>
